import '../Reports/reports.scss';

import * as React from 'react';
import { Col, Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { hideUSTModal } from '../../actions/modalActions';
import { IDailyForms, IHistory } from '../../interfaces';
import { PlantModel } from '../../model/PlantModel';
import { getAllPlantsByRegion } from '../../services/plantService';
import { BasePage } from '../reusableComponents/BasePage';
import { PieChart } from '../reusableComponents/ChartComponents/PieChart';
import { FormFooter } from '../reusableComponents/FormComponents/FormFooter';
import { ListPage } from '../reusableComponents/ListPage';
import { ListFooter } from './ListFooter';
import { ListItem } from './ListItem';

export interface IInspectionsProps {
    instances: PlantModel[];
    dailyForms: IDailyForms;
    showUSTModal: boolean;
    formType: string;
    history: IHistory;
    userId: string;
    selectedDate: string;
    formInstance: PlantModel;
}

export class InspectionsImpl extends React.Component<IInspectionsProps, {}> {

    componentDidMount() {
        this.props.history.push('/inspections');
    }

    promise = async () => {
        await getAllPlantsByRegion(this.props.userId);
    }

    renderPieChart = () => {
        const { dailyForms } = this.props;
        if (!dailyForms) {
            return <div></div>;
        }

        const { dailyForms: { complete, inComplete, dailyFormsData } } = this.props;

        const dailyFormSummary =
            [{ name: 'Complete Forms', value: complete }, { name: 'Incomplete Forms', value: inComplete }];

        return <Col sm={12} xs={12} className="pie-chart-container" >
            <PieChart className="pie-chart-responsive" data={dailyFormSummary} dataKey="value" legends >
            </PieChart>

        </Col>;
    }

    handleFooterYes = () => {
        const { formInstance: { props: { PlantId, Plant_Region } }, selectedDate, formType } = this.props;
        this.props.history.push(`/monthly-checklist-form/${formType}/${PlantId}/${Plant_Region}/${selectedDate}`);
        hideUSTModal();
    }

    handleFooterNo = () => {
        const { formInstance: { props: { PlantId, Plant_Region } }, selectedDate, formType } = this.props;
        this.props.history.push(`/monthly-checklist-form/${formType}/${PlantId}/${Plant_Region}/${selectedDate}`);
        hideUSTModal();
    }

    renderModal = () => {
        return <Modal
            show={this.props.showUSTModal}
            onHide={() => hideUSTModal()}
            container={this}
            className="argos-modal"
            aria-labelledby="contained-modal-title"
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title">
                    Select Form Type
          </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Is this a corrective action follow-up form?
            </Modal.Body>
            <Modal.Footer>
                <FormFooter
                    submitLabel="Yes"
                    cancelLabel="No"
                    onSubmit={this.handleFooterYes}
                    onCancel={this.handleFooterNo}
                />
            </Modal.Footer>
        </Modal>;
    }

    render() {
        const { instances } = this.props;
        return (
            <BasePage className="list-page-base" pageTitle="Inspections" >
                {this.renderModal()}
                <ListPage
                    height="71vh"
                    instances={instances}
                    listItemComponent={ListItem}
                    searchBy={['PlantId', 'Plant_Region', 'State']}
                    instanceOf={'plantInfo'}
                    pageHeadings={['#', 'PlantID', 'Region', 'State']}
                    promise={this.promise}
                    cols={[2, 3, 4, 3]}
                    searchPlaceHolder="Enter state, region or plant id to search..."
                    emptyListMessage="No plants found"
                    listFooter={ListFooter}
                />
            </BasePage>
        );
    }
}

export function mapStateToProps(state) {
    const instances = PlantModel.list(state);
    const showUSTModal = state.modal.get('showUSTModal');
    const formType = state.modal.get('formType');
    const formInstance = state.modal.get('formInstance');
    const selectedDate = state.modal.get('selectedDate');
    const userId = state.login.get('UniqueId');
    return {
        userId, instances, showUSTModal, formType, selectedDate, formInstance
    };
}

export const Inspections =
    withRouter(connect<{}, {}, IInspectionsProps>(mapStateToProps)(InspectionsImpl as any));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Inspections/Inspections.tsx